export default "__VITE_ASSET__2844c05e__"